import {call, put, takeLatest} from "redux-saga/effects";
import request from "../../api/request";
import {addressRoadTypeActions} from "../reducers/addressRoadTypeReducer";

function* getAllAddressRoadTypeSaga(payload) {
    try {
        yield put({
            type: addressRoadTypeActions.FECTCHIN_ALL_ADDRESSROADTYPE,
        });

        yield put({
            type: "SHOW_LOADING",
        });

        const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/addressRoadTypes?page=${payload.value.page}&search=${payload.value.search}&offset=${payload.value.offset}${payload.value.isActive ? '&isActive=' + payload.value.isActive: '' }`;
        const headers = {
            method: "GET",
            headers: new Headers({
                Authorization: `Bearer ${window.localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            }),
        };
        const response = yield call(request, requestURL, headers);

        yield put({
            type: addressRoadTypeActions.FETCH_ADDRESSROADTYPE_SUCCESS,
            value: response,
        });
        yield put({
            type: "HIDE_LOADING",
        });
    } catch (error) {
        yield put({
            type: "HIDE_LOADING",
          });
        console.log(error);

    }
}

function* postAddressRoadTypeSaga(payload) {
    try {
        yield put({type: addressRoadTypeActions.CREATE_ADDRESSROADTYPE_REQUESTING});

        const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/addressRoadTypes`;

        const headers = {
            method: "POST",
            headers: new Headers({
                Authorization: `Bearer ${window.localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            }),
            body: JSON.stringify(payload.value),
        };

        const response = yield call(request, requestURL, headers);

        yield put({
            type: "HIDE_LOADING",
        });
        yield put({
            type: "SHOW_ALERT",
            value: {
                type: "success",
                title: "Successful save",
                message: "Successful save Address Cardinal Point ",
            },
        });
        yield put({
            type: addressRoadTypeActions.CREATE_ADDRESSROADTYPE_SUCCESS,
            value: response,
        });
    } catch (error) {
        yield put({
            type: "HIDE_LOADING",
        });
        yield put({
            type: "SHOW_ALERT",
            value: {
                type: "danger",
                title: "Failed save",
                message: "Failed save City",
            },
        });
        yield put({
            type: addressRoadTypeActions.CREATE_ADDRESSROADTYPE_ERROR,
        });
    }
}

function* getAddressRoadTypeSagaById(payload) {
    try {
        yield put({
            type: addressRoadTypeActions.READ_ADDRESSROADTYPE_REQUESTING,
        });

        yield put({
            type: "SHOW_LOADING",
        });

        const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/addressRoadTypes/${payload.value.id}`;

        const headers = {
            method: "GET",
            headers: new Headers({
                Authorization: `Bearer ${window.localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            }),
        };
        const response = yield call(request, requestURL, headers);

        yield put({
            type: addressRoadTypeActions.READ_ADDRESSROADTYPE_SUCCESS,
            value: response,
        });

        yield put({
            type: addressRoadTypeActions.READ_ADDRESSROADTYPE_SUCCESS,
            value: response,
        });

        yield put({
            type: "HIDE_LOADING",
        });
    } catch (error) {
        yield put({
            type: "HIDE_LOADING",
        });
        yield put({
            type: addressRoadTypeActions.READ_ADDRESSROADTYPE_ERROR,
        });
    }
}

function* deleteAddressRoadTypeSagaById(payload) {
    try {
        yield put({
            type: addressRoadTypeActions.DELETE_ADDRESSROADTYPE_REQUESTING,
        });

        yield put({
            type: "SHOW_LOADING",
        });

        const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/addressRoadTypes/changeState/${payload.value.idAddressRoadType}`;

        const headers = {
            method: "PATCH",
            headers: new Headers({
                Authorization: `Bearer ${window.localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            }),
            body: JSON.stringify(payload.value),
        };

        const response = yield call(request, requestURL, headers);

        yield put({
            type: addressRoadTypeActions.DELETE_ADDRESSROADTYPE_SUCCESS,
            value: response,
        });
        yield put({
            type: "HIDE_LOADING",
        });
        yield put({
            type: "SHOW_ALERT",
            value: {
                type: "success",
                title: payload.value.isActive === false ? "Successful enable" : "Successful disable",
                message: payload.value.isActive === false
                  ? "Successful enable addressRoadType"
                  : "Successful disable addressRoadType",
            },
        });
    } catch (error) {
        yield put({
            type: "HIDE_LOADING",
        });
        yield put({
            type: "SHOW_ALERT",
            value: {
                type: "danger",
                title: "Failed disable",
                message: "Failed disable addressRoadType",
            },
        });
        yield put({
            type: addressRoadTypeActions.DELETE_ADDRESSROADTYPE_ERROR,
        });
    }
}

function* updateAddressRoadTypeSagaById(payload) {
    try {
        yield put({
            type: addressRoadTypeActions.UPDATE_ADDRESSROADTYPE_REQUESTING,
        });

        yield put({
            type: "SHOW_LOADING",
        });

        const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/addressRoadTypes/${payload.value.idAddressRoadType}`;

        const headers = {
            method: "PATCH",
            headers: new Headers({
                Authorization: `Bearer ${window.localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            }),
            body: JSON.stringify(payload.value),
        };

        const response = yield call(request, requestURL, headers);

        yield put({
            type: addressRoadTypeActions.UPDATE_ADDRESSROADTYPE_SUCCESS,
            value: response,
        });
        yield put({
            type: "HIDE_LOADING",
        });
        yield put({
            type: "SHOW_ALERT",
            value: {
                type: "success",
                title: "Successful update",
                message: "Successful update Country",
            },
        });
    } catch (error) {
        yield put({
            type: "HIDE_LOADING",
        });
        yield put({
            type: "SHOW_ALERT",
            value: {
                type: "danger",
                title: "Failed update",
                message: "Failed update Country",
            },
        });
        yield put({
            type: addressRoadTypeActions.UPDATE_UPDATE_ADDRESSROADTYPE_ERROR,
        });
    }
}


export function* watchAllAddressRoadTypeSaga() {
    yield takeLatest(addressRoadTypeActions.FETCH_ADDRESSROADTYPE_REQUEST, getAllAddressRoadTypeSaga);
    yield takeLatest(addressRoadTypeActions.CREATE_ADDRESSROADTYPE_REQUEST, postAddressRoadTypeSaga);
    yield takeLatest(addressRoadTypeActions.READ_ADDRESSROADTYPE_REQUEST, getAddressRoadTypeSagaById);
    yield takeLatest(addressRoadTypeActions.DELETE_ADDRESSROADTYPE_REQUEST, deleteAddressRoadTypeSagaById);
    yield takeLatest(addressRoadTypeActions.UPDATE_ADDRESSROADTYPE_REQUEST, updateAddressRoadTypeSagaById);
}
